/* eslint-disable prettier/prettier */
import { Box, Button, InputBase, makeStyles } from '@material-ui/core'
import { Send } from '@material-ui/icons'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import io from 'socket.io-client'
import { API_URL, JWT_TOKEN } from '../../config'
import Message from './Messge'
 
const useStyles = makeStyles({
  chatboxHeader:{
    background:'rgba(245,241,241)',
    color:'black',
    height:50,
    padding:10,
    fontWeight:'bold',
    fontSize:20,
    borderTopRightRadius:'10px'
  },
  footer:{
    height:'55px',
    background:'rgba(245,241,241)',
    borderRadius:'10px',
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    padding:'0 15px'
 
  },
  component:{
    display:'flex',
    flexDirection:'column',
    justifyContent:'space-between'
  },
  chatboxTop:{
    overflowY:'scroll',
    position:'relative',
    height: '400px'
  }
})

const ENDPOINT = "http://localhost:7000";
//const ENDPOINT = API_URL.root_api;

var  socket,selectedChatCompare;
 
const Chatbox = () => {
  const classes = useStyles()
  const [newMessage,setNewMessage] = useState('')
  const [messages,setMessages] = useState([])
  const [loggedUserId,setloggedUserId] = useState('')
  const [setSocketConnected] = useState(false)
  const [user,setUser] = useState({})
  const selectedChat = useSelector(state => state.selectedChat.data)
  const login = useSelector(state => state.login);
 


  const sendMessage = async(e) => {
    e.preventDefault()
   if(newMessage){
   try {
       let config = {
         headers : {'X-Auth-Token' : JWT_TOKEN},
         params : { id : selectedChat._id}
       }
       setNewMessage('')
       const {data} = await axios.post(API_URL.send_message_api,
        {
          content : newMessage
        },config)

        console.log("SEND MESAGE ",data)
        socket.emit('new message',data.message)
      setMessages([...messages,data.message])
 
     } catch (error) {
      toast.error('Failed to send message', {
        position: 'top-center',
        autoClose: 5000,
        pauseOnHover: false,
      })
     }
   }
  }
 
  const fetchMessages = async() => {
    try {
      let config = { 
        headers : {'X-Auth-Token' : JWT_TOKEN},
        params : { id : selectedChat._id }
      }
      const {data} = await axios.get(API_URL.fetch_all_messages_api,config)
     //console.log(data.message)
      setMessages(data.message)

      socket.emit('join-chat',selectedChat._id);
    } catch (error) {
      console.log(error)
    }
  }

  const fetchUser = async() => {
    try {
      let config = {
        headers : { 'X-Auth-Token'  : JWT_TOKEN},
        params : { user : login.data.username}
      }

      const res = await axios.get(API_URL.fetch_user_api,config)
      setUser(res.data.message)
      setloggedUserId(res.data.message._id)
    } catch (error) {
      
    }
  }

 
  useEffect(()=>{
  
    socket = io(ENDPOINT);
   console.log("Socket",socket)
     socket.emit("setup",user)
    socket.on('connection',() => setSocketConnected(true))
 
 },[])
 
  useEffect(()=>{
      fetchMessages()
      fetchUser()
      selectedChatCompare = selectedChat
  },[selectedChat._id])


   useEffect(()=>{
    socket.on('message-received',(newMessageReceived)=>{
      if(!selectedChat ||  selectedChatCompare._id !== newMessageReceived.chat._id){
        //give notification
      }else {
        setMessages([...messages, newMessageReceived]);
      }
    })
  })




  return (
    <Box className={classes.component}>
    <Box className={classes.chatboxHeader}>{selectedChat
    .users[0]._id === loggedUserId ? selectedChat.users[1].username : selectedChat.users[0].username}</Box>
      <Box className={classes.chatboxTop}>
   
      {messages && messages.map((m,i)=>
        <Message 
            key ={ m._id}
            own={m.sender._id === loggedUserId}
           message={m.content}/>
      )}
    
    
 
 
 
 
 
 
      </Box>
      <Box className={classes.footer}>
        <InputBase
          placeholder="Type your message"
          value={newMessage}
          onChange = { e => setNewMessage(e.target.value)}
          />
        <Button onClick={sendMessage}><Send/></Button>
      </Box>
    </Box>
  )
}
 
export default Chatbox
